import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../users/functions/callBackFunctions";
import React from "react";

export default function standart() {
}

export const fillDetail = () => {
    $("#d-user-alias").html(window.$catalog_users_selectedRow.alias);
    // $("#alias-tooltip").html(window.$catalog_users_selectedRow.alias);
    $("#d-user-email").html(window.$catalog_users_selectedRow.email);
    $("#d-user-organisatie").html(window.$catalog_users_selectedRow.organisatie);
    $("#d-user-organisatie-tooltip").html(
        window.$catalog_users_selectedRow.organisatie
    );

    $("#d-user-mandate-organisatie").html(
        window.$catalog_users_selectedRow.mandateOrganisatie
    );
    $("#d-user-mandate-organisatie-tooltip").html(
        window.$catalog_users_selectedRow.mandateOrganisatie
    );
    $("#d-user-gebruikersrollen").html(
        window.$catalog_users_selectedRow.gebruikersrollen
    );
    $("#d-user-gebruikersrollen-tooltip").html(
        window.$catalog_users_selectedRow.gebruikersrollen
    );
    $("#startDate").attr(
        "placeholder",
        window.$catalog_users_selectedRow.startDate
    );
    if (window.$catalog_users_selectedRow.isActive)
        $("#d-user-is-active").attr("checked", "checked");
    else $("#d-user-is-active").removeAttr("checked");

    //editSide
};

export function fillDetailOrganization(organization) {
    $("#organisatie-naam").html(organization ? organization.naamorganisatie : "");
    $("#organisatie-email").html(organization ? organization.email : "");
    $("#organisatie-website").html(organization ? organization.website : "");
    $("#organisatie-straat").html(organization ? organization.straat : "");
    $("#organisatie-nummer").html(organization ? organization.nummer : "");
    $("#organisatie-postcode").html(organization ? organization.postcode : "");
    $("#organisatie-woonplaats").html(
        organization ? organization.woonplaats : ""
    );
    $("#organisatie-opmerking").html(organization ? organization.opmerking : "");

    if (organization ? organization.actief : "")
        $("#organisatie-active").attr("checked", "checked");
    else $("#organisatie-active").removeAttr("checked");
    if (organization ? organization.isuitvoerder : "")
        $("#organisatie-uitvoerder").attr("checked", "checked");
    else $("#organisatie-uitvoerder").removeAttr("checked");



    if (organization.isEditable) {
        $("#organization-edit-button").removeClass("d-none");
        $("#timestamp_updated_div").removeClass("d-none");
        $("#timestamp_created_div").removeClass("d-none");

        const relationsRow = $("#relations-row")
        relationsRow.removeClass("d-none");

        $("#back-page-link-inner-text").html("&nbsp;Terug naar Organisaties")
        //editSide

        $("#timestamp_created").html(organization ?
            new Date(organization.timestampCreated).toLocaleString('nl').split(" ")[0]
            : "");
        $("#timestamp_updated").html(organization ?
            new Date(organization.timestampUpdated).toLocaleString('nl').split(" ")[0]
            : "");


        const name = $("#organization-edit-input-name")
        name.val(
            organization.naamorganisatie
        );
        name.attr('data-selected', organization.identification)
        $("#organization-edit-input-email").val(
            organization.emailClear
        );
        $("#organization-edit-input-website").val(
            organization.website
        );
        $("#organization-edit-input-street").val(
            organization.straat
        );
        $("#organization-edit-input-number").val(
            organization.nummer
        );
        $("#organization-edit-input-post-code").val(
            organization.postcode
        );
        $("#organization-edit-input-residence").val(
            organization.woonplaats
        );
        $("#organization-edit-input-remark").val(
            organization.opmerking
        );
        $("#organization-edit-input-active").prop('checked', organization.actief);
        $("#organization-edit-input-is-general-executor").prop('checked', organization.isuitvoerder);
        // $("#e-algemeen-starten").val(
        //     organization.startenna
        // );
        // $("#e-algemeen-starten").val(
        //     organization.startenna
        // );
        let box = ""
        let workSource = ""
        let workPlan = ""
        let measure = ""
        let obligation = ""

        if (Array.isArray(organization.relations))
            for (const relation of organization.relations){ //can be uniterable
                switch (relation.relationships["related_instance"].relationships.definition.code) {
                    case "WERKBRON":
                        workSource = workSource.concat(workSource, getBoxInnerHtml(relation.relationships["related_instance"].name))
                        break;
                    case "WERKPLAN":
                        workPlan = workPlan.concat(workPlan, getBoxInnerHtml(relation.relationships["related_instance"].name))
                        break;
                    case "MAATREGEL":
                        measure = measure.concat(measure, getBoxInnerHtml(relation.relationships["related_instance"].name))
                        break;
                    case "VERPLICHTING":
                        obligation = obligation.concat(obligation, getBoxInnerHtml(relation.relationships["related_instance"].name))
                        break;
                }
            }

 /*       for (let i = 0; i < 4; i++) {
            getBox()
        }*/
        if (workSource !== "")
            box = box.concat(getBox(getBoxTitleInnerHtml("Werkbron"), workSource))
        if (workPlan !== "")
            box = box.concat(getBox(getBoxTitleInnerHtml("Werkplan"), workPlan))
        if (measure !== "")
            box = box.concat(getBox(getBoxTitleInnerHtml("Maatregel"), measure))
        if (obligation !== "")
            box = box.concat(getBox(getBoxTitleInnerHtml("Verplichting"), obligation))

        relationsRow.html(box);
    } else {
        $("#organization-edit-button").addClass("d-none");
        $("#timestamp_updated_div").addClass("d-none");
        $("#timestamp_created_div").addClass("d-none");
    }

}

function getBoxInnerHtml (value){
    return `<div class="box-title-2" id="relation">${value}</div>`
}

function getBoxTitleInnerHtml (value){
    return `<div class="box-title-1" id="relation">${value}</div>`
}

function getBox(title, value){
    return `<div class="col-lg-4 text-center" >
                <div class="box-detail-empty" >
                <div class="box-detail-ceiling" >
                ${title}
                </div>
                
                
                <div class="box-detail-scroll" >
                ${value}
                </div>
                
                </div>

            </div>`
}

export const rowsHandleDelete = async () => {
    $("#cover-spin").show(0);
    window.$catalog_users_selectedIds.forEach(async (element) => {
        GC.sleep(2000).then(async () => {
            let result = await omnimap
                .UserApiAction(
                    element,
                    "DELETE",
                    null,
                    null,
                    window.$catalog_users_token
                )
                .catch((error) => {
                    console.log(error);
                });
            if (result.result.status !== "OK") {
                alert(`${element} error`);
            }
        });

        CallBackFunctions.RowsDeletedCallBack(
            window.$catalog_management_units_token
        );
    });

    await omnimap
        .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_token)
        .then((result) => {
            CallBackFunctions.FillTableCallBack(result, 1);
        });
};
